<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button" class="active">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'MemberCoupon' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("優惠專區") }}
            </router-link>
          </li>
          <li v-if="local != 'jp' && hasInvite">
            <router-link :to="{ name: 'InvitEvent' }" tag="button">
              <img src="img/member_icon_friends.svg" alt="" />
              {{ $t("邀請朋友") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main" v-if="UserData.User">
          <div class="bg-box">
            <h1>{{ $t("會員資料") }}</h1>
            <hr />
            <ul class="text-box">
              <li>
                <div>{{ $t("帳號") }}</div>
                <div>{{ UserData.User.Account }}</div>
              </li>
              <li v-if="!UserData.User.IsOAuth">
                <div>{{ $t("手機號碼") }}</div>
                <div v-if="UserData.User.Phone">{{ hideInfo(UserData.User.Phone, 7, 3) }}</div>
                <div v-else>未設定</div>
              </li>
              <li v-if="UserData.CInfoData != null">
                <div>{{ $t("姓名") }}</div>
                <div>{{ hideInfo(UserData.CInfoData.o_maas_cinfo_name, 1, 1) }}</div>
              </li>
              <li v-if="UserData.CInfoData != null">
                <div>{{ $t("性別") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_gender }}</div>
              </li>
              <li v-if="UserData.CInfoData != null &&
                UserData.CInfoData.o_maas_cinfo_birth != ''
              ">
                <div>{{ $t("出生年月") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_birth }}</div>
              </li>
              <li v-if="UserData.CInfoData != null">
                <div>{{ $t("國籍") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_nation }}</div>
              </li>
              <!-- <li v-if="UserData.CInfoData != null">
                <div>{{ $t("MeN Go卡號") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_name }}</div>
              </li>
              <li v-if="UserData.CInfoData != null">
                <div>{{ $t("MeN Go卡狀態") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_name }}</div>
              </li> -->
              <hr v-if="!UserData.User.IsOAuth" />
              <li v-if="!UserData.User.IsOAuth">
                <div>{{ $t("更換手機號碼") }}</div>
                <div class="phone-change box" style="position: relative">
                  <div class="phone">
                    <vue-tel-input v-bind="vtiProps" @input="onInput"></vue-tel-input>
                  </div>
                  <div class="code-box box" v-if="!issned">
                    <button class="get-code" @click="getPinCode">
                      {{ $t("獲取驗證碼") }}
                    </button>
                  </div>
                  <span id="showPhone" @click="viewphone = !viewphone"><img
                      :src="viewphone ? 'img/eyes-n.png' : 'img/eyes-y.png'" style="width: auto; height: 16px" /></span>
                </div>
              </li>
              <li v-if="issned">
                <div>
                  <label for="newPasswordConfirm">{{ $t("手機認證碼") }}</label>
                </div>
                <div class="password-change box">
                  <input :placeholder="$t('請輸入手機簡訊認證碼')" type="text" class="form-control" id="inputCode"
                    v-model="pincode_input" />
                  <button class="" @click="handleChangePhone">
                    {{ $t("確認更換手機號碼") }}
                  </button>
                </div>
              </li>
              <hr />
              <li v-if="!UserData.User.IsOAuth && !issned">
                <div>
                  <label for="password">{{ $t("舊密碼") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入舊密碼')" type="password" class="form-control" id="password"
                    v-model="password" maxlength="25" />
                </div>
              </li>
              <li v-if="!UserData.User.IsOAuth && !issned">
                <div>
                  <label for="newPassword">{{ $t("新密碼") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入新密碼')" type="password" class="form-control" id="newPassword"
                    v-model="newPassword" maxlength="25" />
                </div>
              </li>
              <li v-if="!UserData.User.IsOAuth && !issned">
                <div>
                  <label for="newPasswordConfirm">{{ $t("確認密碼") }}</label>
                </div>
                <div class="password-change box">
                  <input :placeholder="$t('確認密碼')" type="password" class="form-control" id="newPasswordConfirm"
                    v-model="newPasswordConfirm" maxlength="25" />
                  <button class="" @click="handleChangePassword">
                    {{ $t("更改密碼") }}
                  </button>
                </div>
              </li>
              <hr v-if="!UserData.User.IsOAuth && !issned" />
              <li>
                <div>
                  <label for="memberName">{{ $t("會員姓名") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入會員姓名(選填)')" type="text" class="form-control" id="memberName"
                    v-model="memberName" maxlength="1000" autocomplete="off" />
                </div>
              </li>
              <li>
                <div>
                  <label for="city">{{ $t("縣市") }}</label>
                </div>
                <div>
                  <select class="form-control" id="city">
                    <option v-for="City in UserData.Citys" :key="City.o_maas_city_seq" :value="City.o_maas_city_seq">
                      {{
                        local == "en"
                          ? City.o_maas_city_name_en
                          : City.o_maas_city_name_zh_tw
                      }}
                    </option>
                  </select>
                </div>
              </li>
              <li>
                <div>
                  <label for="town">{{ $t("鄉鎮區") }}</label>
                </div>
                <div>
                  <select class="form-control" id="town">
                    <option v-for="Town in UserData.Towns" :key="Town.o_maas_town_seq" :value="Town.o_maas_town_seq">
                      {{
                        local == "en"
                          ? Town.o_maas_town_name_en
                          : Town.o_maas_town_name_zh_tw
                      }}
                    </option>
                  </select>
                </div>
              </li>
              <li style="display: none">
                <div>
                  <label for="address">{{ $t("地址") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入地址(選填)')" type="text" class="form-control" id="address"
                    v-model="address" />
                </div>
              </li>
              <li>
                <div>
                  <label for="gender">{{ $t("性別") }}</label>
                </div>
                <div class="password-change box">
                  <select class="form-control" id="gender" v-model="gender">
                    <option value="" selected>{{ $t("未設定") }}</option>
                    <option value="M">{{ $t("男性") }}</option>
                    <option value="F">{{ $t("女性") }}</option>
                  </select>
                </div>
              </li>
              <li>
                <div>
                  <label for="birthYear">{{ $t("出生年次") }}</label>
                </div>
                <div>
                  <select class="form-control" id="birthYear" v-model="birthYear">
                    <option value="">{{ $t("未設定") }}</option>
                    <option v-for="year in birthYears" :key="year" :value="year">{{ year }}</option>
                  </select>
                </div>
              </li>
              <li>
                <div>
                  <label for="contactPhone">{{ $t("聯絡電話") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入聯絡電話(選填)')" type="text" class="form-control" id="contactPhone"
                    v-model="contactPhone" maxlength="40" autocomplete="off" />
                </div>
              </li>
               <li style="position: relative">
                <div>
                  <label for="email">{{ $t("電子信箱") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入電子信箱(選填)')" :type="viewemail ? 'text' : 'password'" class="form-control"
                    id="email" v-model="email" maxlength="100" autocomplete="off" autocorrect="off" autocapitalize="off"
                    spellcheck="false" />
                  <span id="showEmail" @click="viewemail = !viewemail"><img
                      :src="viewemail ? 'img/eyes-n.png' : 'img/eyes-y.png'" style="width: auto; height: 16px" /></span>
                </div>
              </li>
              <li>
                <div>
                  <label for="school">{{ $t("學校名稱") }}</label>
                </div>
                <div style="width: 190px;">
                  <!-- <input :placeholder="$t('請輸入學校名稱(選填)')" type="text" class="form-control" id="school" v-model="school"
                    maxlength="50" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" /> -->
                  <!-- <select2 v-model="school" :options="SchoolCitys" :settings="{ placeholder: '請選擇', language: 'zh-TW', allowClear: true }" style="width: 100%; margin-right: 0;" /> -->
                  <select v-select2="{ placeholder: '請直接輸入關鍵字', value: school }" v-model="school">
                    <option value="">無</option>
                    <optgroup v-for="(SchoolCity, index) in UserData.SchoolCitys" :label="SchoolCity.City">
                      <option v-for="(School, idx) in SchoolCity.Schools" :value="School.Name">{{ School.Name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </li>
              <li class="cooperation-section">
                <div class="cooperation-consent-row" role="button" tabindex="0"
                  :aria-checked="isCooperationDataConsent ? 'true' : 'false'"
                  @click.stop="handleCooperationConsent"
                  @keydown.enter.prevent="handleCooperationConsent"
                  @keydown.space.prevent="handleCooperationConsent">
                  <div class="cooperation-consent-label">
                    <input type="checkbox" :checked="isCooperationDataConsent"
                      tabindex="-1" aria-hidden="true" />
                    <span>{{ $t("已同意【企業合作專案資料提供宣告】") }}</span>
                  </div>
                </div>
                <template v-if="isCooperationDataConsent">
                  <div class="cooperation-field-row">
                    <div>
                      <label for="CUId">{{ $t("專案合作單位") }}</label>
                    </div>
                    <div>
                      <select class="form-control" id="CUId" v-model="CUId">
                        <option value="-1">{{ $t("請選擇") }}</option>
                        <option v-for="CooperationUnit in UserData.CooperationUnits" :key="CooperationUnit.CUId"
                          :value="CooperationUnit.CUId">
                          {{ CooperationUnit.Name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="cooperation-field-row">
                    <div>
                      <label for="taxID">{{ $t("統一編號") }}</label>
                    </div>
                    <div>
                      <input :placeholder="$t('請輸入統一編號')" type="text" class="form-control" id="taxID"
                        v-model="taxID" maxlength="20" autocomplete="off" autocorrect="off" autocapitalize="off"
                        spellcheck="false" />
                    </div>
                  </div>
                  <div class="cooperation-field-row">
                    <div>
                      <label for="unitId">{{ $t("職工編號") }}</label>
                    </div>
                    <div>
                      <input :placeholder="$t('請輸入職工編號')" type="text" class="form-control" id="unitId"
                        v-model="unitId" maxlength="50" autocomplete="off" autocorrect="off" autocapitalize="off"
                        spellcheck="false" />
                    </div>
                  </div>
                </template>
              </li>
              
              <li>
                <div></div>
                <div class="box">
                  <button class="" @click="handleChangeInfo">
                    {{ $t("更新資訊") }}
                  </button>
                </div>
              </li>
              <hr />
              <li>
                <div>{{ $t("登出此帳號") }}</div>
                <div class="box">
                  <button class="change-btn" @click="logout">
                    {{ $t("登出") }}
                  </button>
                </div>
              </li>
              <li>
                <div>{{ $t("註銷帳號") }}</div>
                <div class="box">
                  <button class="change-btn" @click="applyClear">
                    {{ $t("申請註銷此帳號") }}
                  </button>
                </div>
              </li>
              <hr />
              <li>
                <div>Ver.</div>
                <div>{{ GLOBAL.localVer }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueTelInput, {
  autoDefaultCountry: true,
  defaultCountry: 886,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
  inputOptions: {
    placeholder: "",
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "交易記錄": "交易記錄",
    "其他資訊": "其他資訊",
    "帳號": "帳號",
    "手機號碼": "手機號碼",
    "姓名": "姓名",
    "性別": "性別",
    "出生年月": "出生年月",
    "國籍": "國籍",
    "更換手機號碼": "更換手機號碼",
    "獲取驗證碼": "獲取驗證碼",
    "手機認證碼": "手機認證碼",
    "請輸入手機簡訊驗證碼": "請輸入手機簡訊驗證碼",
    "確認更換手機號碼": "確認更換手機號碼",
    "舊密碼": "舊密碼",
    "請輸入舊密碼": "請輸入舊密碼",
    "新密碼": "新密碼",
    "請輸入新密碼": "請輸入新密碼",
    "確認密碼": "確認密碼",
    "更改密碼": "更改密碼",
    "登出此帳號": "登出此帳號",
    "登出": "登出",
    "錯誤": "錯誤",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "取得會員資訊過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "手機號碼格式錯誤": "手機號碼格式錯誤",
    "更換手機號碼成功，請使用新的手機號碼重新登入": "更換手機號碼成功，請使用新的手機號碼重新登入",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次": "重設密碼與確認重設密碼不符合, 請確認後再試一次",
    "重設密碼成功": "重設密碼成功",
    "註銷此帳號": "註銷此帳號",
    "申請註銷此帳號": "申請註銷此帳號",
    "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。": "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。",
    "送出": "送出",
    "取消": "取消",
    "請輸入DELETE後再按下送出": "請輸入DELETE後再按下送出",
    "帳號註銷成功": "帳號註銷成功",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
    "縣市": "縣市",
    "鄉鎮區": "鄉鎮區",
    "地址": "地址",
    "請輸入地址(選填)": "請輸入地址(選填)",
    "統一編號": "統一編號",
    "請輸入統一編號(選填)": "請輸入統一編號(選填)",
    "學校名稱": "學校名稱",
    "請輸入學校名稱(選填)": "請輸入學校名稱(選填)",
    "電子信箱": "電子信箱",
    "請輸入電子信箱(選填)": "請輸入電子信箱(選填)",
    "更新資訊": "更新資訊",
    "註銷帳號": "註銷帳號",
    "專案合作單位": "專案合作單位",
    "請選擇(選填)": "請選擇(選填)",
    "請選擇": "請選擇",
    "職工編號": "職工編號",
    "請輸入職工編號(選填)": "請輸入職工編號(選填)",
    "會員姓名": "會員姓名",
    "請輸入會員姓名(選填)": "請輸入會員姓名(選填)",
    "出生年次": "出生年次",
    "聯絡電話": "聯絡電話",
    "請輸入聯絡電話(選填)": "請輸入聯絡電話(選填)",
    "已同意【企業合作專案資料提供宣告】": "已同意【企業合作專案資料提供宣告】",
    "請輸入統一編號": "請輸入統一編號",
    "請輸入職工編號": "請輸入職工編號",
    "請完整填寫專案合作單位、統一編號及職工編號": "請完整填寫專案合作單位、統一編號及職工編號",
    "出生年次格式錯誤": "出生年次格式錯誤",
    "請勾選同意後再按確定": "請勾選同意後再按確定",
  },
  en: {
    "會員資料": "Member info",
    "我的套票": "My pass",
    "卡片資料": "Card info",
    "套票兌換": "Redeem pass",
    "交易記錄": "Card record",
    "其他資訊": "Other info",
    "帳號": "Account ",
    "手機號碼": "Mobile number",
    "姓名": "Name",
    "性別": "Gender",
    "出生年月": "Date of birth",
    "國籍": "Nationality",
    "更換手機號碼": "Change the mobile number",
    "獲取驗證碼": "Get the verification code",
    "手機認證碼": "Mobile verification code",
    "請輸入手機簡訊驗證碼": "Please enter the verification code",
    "確認更換手機號碼": "Confirm to change the mobile number",
    "舊密碼": "Old password",
    "請輸入舊密碼": "Please enter the old password",
    "新密碼": "New password",
    "請輸入新密碼": "Please enter the new password",
    "確認密碼": "Confirm the password",
    "更改密碼": "Change the password",
    "登出此帳號": "Log out the account",
    "登出": "Log out",
    "錯誤": "Error",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "確定": "Confirm",
    "手機號碼格式錯誤": "Wrong mobile number format",
    "更換手機號碼成功，請使用新的手機號碼重新登入": "Done. Please use the new mobile number to log in.",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次": "Please confirm the new password and try again.",
    "重設密碼成功": "Password reset",
    "註銷此帳號": "Delete Account",
    "申請註銷此帳號": "Apply",
    "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。": "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。<br /><br /><span style=\"color: red;\">本人已充分瞭解並同意承擔其後果<br />請輸入 <span style=\"color: blue;\">DELETE</span> 後按下送出。</span>",
    "送出": "Submit",
    "取消": "Cancel",
    "請輸入DELETE後再按下送出": "Please enter \"DELETE\" and submit.",
    "帳號註銷成功": "Account deleted success",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
    "縣市": "County (City)",
    "鄉鎮區": "Township, District",
    "地址": "Address",
    "請輸入地址(選填)": "Please enter the Address (optional)",
    "統一編號": "Tax ID Number",
    "請輸入統一編號(選填)": "Please enter the Tax ID Number (optional)",
    "學校名稱": "School Name",
    "請輸入學校名稱(選填)": "Please enter the School Name (optional)",
    "電子信箱": "Email",
    "請輸入電子信箱(選填)": "Please enter the Email (optional)",
    "更新資訊": "Update Info",
    "註銷帳號": "Delete Account",
    "專案合作單位": "Project Partnership",
    "請選擇(選填)": "Select",
    "請選擇": "Select",
    "職工編號": "Employee Number",
    "請輸入職工編號(選填)": "Employee Number",
    "會員姓名": "Member Name",
    "請輸入會員姓名(選填)": "Please enter the member name (optional)",
    "出生年次": "Birth Year",
    "聯絡電話": "Contact Phone",
    "請輸入聯絡電話(選填)": "Please enter the contact phone (optional)",
    "已同意【企業合作專案資料提供宣告】": "Agreed to the Project Partnership Data Disclosure",
    "請輸入統一編號": "Please enter the Tax ID Number",
    "請輸入職工編號": "Please enter the Employee Number",
    "請完整填寫專案合作單位、統一編號及職工編號": "Please complete the project partnership, Tax ID and employee number",
    "出生年次格式錯誤": "Invalid birth year",
    "請勾選同意後再按確定": "Please check the consent box before confirming",
  },
  jp: {
    "會員資料": "マイページ",
    "我的套票": "購入/予約履歴",
    "卡片資料": "卡片資料",
    "套票兌換": "チケット引き換え",
    "交易記錄": "交易記錄",
    "其他資訊": "その他の情報",
    "帳號": "アカウント番号",
    "手機號碼": "電話番号",
    "姓名": "姓名",
    "性別": "性別",
    "出生年月": "出生年月",
    "國籍": "國籍",
    "更換手機號碼": "電話番号の変更",
    "獲取驗證碼": "認証コードを受け取る",
    "手機認證碼": "携帯電話認証コード",
    "請輸入手機簡訊驗證碼": "携帯電話のSMS認証コードを入力してください",
    "確認更換手機號碼": "電話番号変更の確認",
    "舊密碼": "旧パスワード",
    "請輸入舊密碼": "旧パスワードを入力してください",
    "新密碼": "新しいパスワード",
    "請輸入新密碼": "新しいパスワードを入力してください",
    "確認密碼": "パスワード確認",
    "更改密碼": "パスワード変更",
    "登出此帳號": "このアカウントからログアウトする",
    "登出": "ログアウトする",
    "錯誤": "エラー",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "会員情報取得中にエラーが発生しました,時間をおいてから再度お試しください",
    "確定": "確定",
    "手機號碼格式錯誤": "電話番号の形式が正しくありません",
    "更換手機號碼成功，請使用新的手機號碼重新登入": "電話番号の変更に成功しました,新しい電話番号を入力して再度ログインしてください",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次": "新しいパスワードと新しいパスワード(確認用)が一致しません,ご確認の上、再度お試しください",
    "重設密碼成功": "パスワードのリセットが完了しました",
    "註銷此帳號": "このアカウントを削除する",
    "申請註銷此帳號": "このアカウントの削除を申請する",
    "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。": "ご注意ください！アカウントを削除すると,アカウント情報を復元できなくなり,",
    "送出": "送信",
    "取消": "取消",
    "請輸入DELETE後再按下送出": "「DELETE」と入力した後、送信を押してください",
    "帳號註銷成功": "アカウントのログアウトに成功",
    "卡片交易紀錄": "カード取引履歴",
    "減碳計算": "二酸化炭素削減計算",
    "縣市": "都道府県",
    "鄉鎮區": "市区町村",
    "地址": "住所",
    "請輸入地址(選填)": "住所を入力してください(任意)",
    "統一編號": "パスポート番号",
    "請輸入統一編號(選填)": "パスポート番号を入力してください(任意)",
    "學校名稱": "学校の名前",
    "請輸入學校名稱(選填)": "学校の名前を入力してください(任意)",
    "電子信箱": "メールアドレス",
    "請輸入電子信箱(選填)": "メールアドレスを入力してください(任意)",
    "更新資訊": "情報を更新する",
    "註銷帳號": "アカウントをキャンセルする",
    "專案合作單位": "プロジェクト提携部門",
    "請選擇(選填)": "選んでください",
    "請選擇": "選んでください",
    "職工編號": "従業員番号",
    "請輸入職工編號(選填)": "従業員番号を入れてください",
    "會員姓名": "会員氏名",
    "請輸入會員姓名(選填)": "会員氏名を入力してください（任意）",
    "出生年次": "生年",
    "聯絡電話": "連絡先電話番号",
    "請輸入聯絡電話(選填)": "連絡先電話番号を入力してください（任意）",
    "已同意【企業合作專案資料提供宣告】": "企業提携プロジェクトのデータ提供に同意済み",
    "請輸入統一編號": "番号を入力してください",
    "請輸入職工編號": "従業員番号を入力してください",
    "請完整填寫專案合作單位、統一編號及職工編號": "提携先、番号、従業員番号をすべて入力してください",
    "出生年次格式錯誤": "生年の形式が正しくありません",
    "請勾選同意後再按確定": "同意欄にチェックしてから確定してください",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "MemberInfo",
  i18n,
  data() {
    return {
      UserData: {},
      countryCallingCode: "",
      number: "",
      valid: false,
      issned: false,
      pincode_input: "",
      pincode: "",
      pincodeCheck: false,
      password: "",
      newPassword: "",
      newPasswordConfirm: "",
      vtiProps: {
        disabled: false,
      },
      phone: "",
      memberName: "",
      birthYear: "",
      contactPhone: "",
      address: "",
      CUId: -1,
      taxID: "",
      unitId: "",
      isCooperationDataConsent: false,
      school: "",
      email: "",
      gender: "",
      Citys: [],
      Towns: [],
      local: "zh_tw",
      viewphone: false,
      viewemail: false,
      SchoolCitys: [],
      IsTester: false,
      hasInvite: false,
      SMSCheckNumber: "",
    };
  },
  computed: {
    birthYears() {
      var years = [];
      var currentYear = new Date().getFullYear();
      for (var year = 1900; year <= currentYear; year++) {
        years.push(year);
      }
      return years;
    },
  },
  watch: {
    memberName(newValue) {
      if (newValue && newValue.indexOf("|") >= 0) {
        this.$nextTick(() => {
          this.memberName = newValue.replace(/\|/g, "");
        });
      }
    },
    contactPhone(newValue) {
      if (newValue && newValue.indexOf("|") >= 0) {
        this.$nextTick(() => {
          this.contactPhone = newValue.replace(/\|/g, "");
        });
      }
    },
    taxID(newValue, oldValue) {
      var rules = new RegExp(/[^0-9]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.taxID = newValue.replace(rules, '');
        })
      }
    },
    unitId(newValue, oldValue) {
      var rules = new RegExp(/[^a-zA-Z0-9@_\-.\u4E00-\u9FA5]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.unitId = newValue.replace(rules, '');
        })
      }
    },
    email(newValue, oldValue) {
      var rules = new RegExp(/[^a-zA-Z0-9@_.]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.email = newValue.replace(rules, '');
        })
      }
    },
    viewphone(newValue, oldValue) {
      if (newValue) {
        $(".vti__input").addClass("show_phone");
      } else {
        $(".vti__input").removeClass("show_phone");
      }
    },
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Member",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得會員資訊過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.UserData = JSON.parse(res.data);
          that.memberName = that.UserData.User.Name || "";
          that.birthYear = that.UserData.User.BirthYear || "";
          that.contactPhone = that.UserData.User.ContactPhone || "";
          that.address = that.UserData.User.Address;
          that.CUId = that.UserData.User.CUId;
          that.taxID = that.UserData.User.TaxID;
          that.unitId = that.UserData.User.UnitId;
          that.isCooperationDataConsent = that.UserData.User.IsCooperationDataConsent === true;
          that.school = that.UserData.User.School;
          that.email = that.UserData.User.Email;
          that.gender = that.UserData.User.Sex;
          that.Citys = that.UserData.Citys;
          that.Towns = that.UserData.Towns;
          that.SchoolCitys = that.UserData.SchoolCitys;
          that.IsTester = that.UserData.IsTester;
          that.hasInvite = that.UserData.hasInvite;
          that.$nextTick(function () {
            that.initializeMemberControls();
          });
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-information");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  beforeDestroy: function () {
    $("#city").off("change.memberInfo");
  },
  methods: {
    initializeMemberControls() {
      let that = this;
      $("#city")
        .off("change.memberInfo")
        .on("change.memberInfo", function () {
          var o_maas_town_city_seq = $(this).find("option:selected").val();
          $.ajax({
            type: "post",
            url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/GetTown",
            data: {
              o_maas_town_city_seq: o_maas_town_city_seq,
            },
            success: function (result) {
              $("#town").find("option").remove();
              var data = jQuery.parseJSON(result.items);
              $.each(data, function (i, item) {
                $("#town").append(
                  '<option value="' + item.id + '">' + item.text + "</option>"
                );
              });
              $("#town").val($("#town option:first").val());
            },
          });
        });
    },
    onInput(phone, phoneObject, input) {
      this.countryCallingCode = phoneObject.countryCallingCode;
      this.number = phoneObject.number;
      this.valid = phoneObject.valid;
    },
    getPinCode() {
      if (!this.valid) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("手機號碼格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      } else {
        let countryCallingCode =
          this.countryCallingCode == null ? "" : this.countryCallingCode;
        let number = this.number == null ? "" : this.number;
        // 組合並送出
        let token = AES.encrypt(countryCallingCode + "|" + number);
        let that = this;
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/MemberCheckNumber",
          type: "post",
          data: {
            token: token,
            loginToken: Storage.get("ek_login_token"),
          },
          dataType: "json",
          error: function () { },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              that.vtiProps.disabled = true;
              that.issned = true;
              that.SMSCheckNumber = res.SMSCheckNumber;
            } else if (res.error_msg) {
              var error_msg = JSON.parse(res.error_msg);
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          },
        });
      }
    },
    handleChangePhone() {
      if (!this.pincode_input) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請輸入手機簡訊驗證碼"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      let countryCallingCode =
        this.countryCallingCode == null ? "" : this.countryCallingCode;
      let number = this.number == null ? "" : this.number;
      let token = AES.encrypt(
        countryCallingCode + "|" + number + "|" + this.SMSCheckNumber + "|" + this.pincode_input
      );
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/MemberChangePhone",
        type: "post",
        data: {
          token: token,
          loginToken: Storage.get("ek_login_token"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("更換手機號碼成功，請使用新的手機號碼重新登入"),
              showConfirmButton: false,
              timer: 3000,
              didDestroy: () => {
                Storage.remove("ek_login_token");
                //location.reload();
                // 返回首頁
                location.href = "/#/Login";
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
            that.vtiProps.disabled = false;
            that.issned = false;
            that.pincode_input = "";
            that.pincodeCheck = false;
          }
        },
      });
    },
    handleChangePassword() {
      let password = this.password;
      let newPassword = this.newPassword;
      let newPasswordConfirm = this.newPasswordConfirm;
      if (newPassword != newPasswordConfirm) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("重設密碼與確認重設密碼不符合, 請確認後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      let token = AES.encrypt(
        password + "|" + newPasswordConfirm
      );
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/MemberChangePassword",
        //url: "https://localhost:44321/Html/MemberChangePassword",
        type: "post",
        data: {
          token: token,
          loginToken: Storage.get("ek_login_token"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("重設密碼成功"),
              showConfirmButton: false,
              timer: 3000,
              didDestroy: () => {
                Storage.remove("ek_login_token");
                location.href = "/#/Login";
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
    handleCooperationConsent() {
      if (this.isCooperationDataConsent) {
        this.isCooperationDataConsent = false;
        this.CUId = -1;
        this.taxID = "";
        this.unitId = "";
        return;
      }

      let that = this;
      this.$swal({
        heightAuto: false,
        title: "企業合作資料提供宣告",
        html: `
          <div style="text-align: left; line-height: 1.7;">
            <p>當您於 MeN Go 平台選擇合作企業／機關時，表示您同意 MeNGo 依《隱私權聲明》第貳項第五款第3點規定，於該企業／機關與 MeNGo 合作專案之執行範圍內，提供您的相關資訊予該企業／機關。</p>
            <p>提供資料說明如下：</p>
            <p>一、提供資料項目：依合作專案內容及執行需要，提供之資料可能包含個人描述（C011）、旅行及其他遷徙細節（C034）及財務交易（C093）等個人資料類別；實際提供項目將以合作專案執行所必要者為限。</p>
            <p>二、資料提供期間：至您移除所選合作企業／機關或該企業／機關合作專案終止之日止。</p>
            <p>三、資料利用目的：供合作企業/機關辦理員工福利、交通補助、通勤服務、活動推廣、統計分析等其他與合作專案相關之用途使用。</p>
          </div>
        `,
        input: "checkbox",
        inputValue: 0,
        inputPlaceholder: "我已充分了解並同意上述內容，並同意 MeN Go 於合作專案執行期間內，依前述目的提供相關資料予所選合作企業／機關。",
        showCancelButton: true,
        confirmButtonText: this.$t("確定"),
        cancelButtonText: this.$t("取消"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          var confirmButton = that.$swal.getConfirmButton();
          var consentCheckbox = that.$swal.getInput();
          confirmButton.disabled = true;
          consentCheckbox.addEventListener("change", function () {
            confirmButton.disabled = !this.checked;
          });
        },
        preConfirm: () => {
          var consentCheckbox = that.$swal.getInput();
          if (!consentCheckbox || !consentCheckbox.checked) {
            that.$swal.showValidationMessage(that.$t("請勾選同意後再按確定"));
            return false;
          }
          return true;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          that.isCooperationDataConsent = true;
        }
      });
    },
    handleChangeInfo() {
      if (this.email != "" && !this.validateEmail(this.email)) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請輸入一個正確的電子郵件地址"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        this.sending = false;
        return;
      }

      var currentYear = new Date().getFullYear();
      if (this.birthYear !== "" &&
        (Number(this.birthYear) < 1900 || Number(this.birthYear) > currentYear)) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("出生年次格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }

      if (this.isCooperationDataConsent &&
        (Number(this.CUId) <= 0 || !String(this.taxID || "").trim() || !String(this.unitId || "").trim())) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請完整填寫專案合作單位、統一編號及職工編號"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }

      if (!this.isCooperationDataConsent) {
        this.CUId = -1;
        this.taxID = "";
        this.unitId = "";
      }

      let token = AES.encrypt(
        $("#city").val() +
        "|" +
        $("#town").val() +
        "|" +
        this.address +
        "|" +
        this.taxID +
        "|" +
        this.school +
        "|" +
        this.email +
        "|" +
        this.gender +
        "|" +
        this.CUId +
        "|" +
        this.unitId +
        "|" +
        this.memberName +
        "|" +
        this.birthYear +
        "|" +
        this.contactPhone +
        "|" +
        (this.isCooperationDataConsent ? "1" : "0")
      );
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/MemberChangeInfo",
        type: "post",
        data: {
          token: token,
          loginToken: Storage.get("ek_login_token"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.UserData.User.Name = that.memberName;
            that.UserData.User.BirthYear = that.birthYear;
            that.UserData.User.ContactPhone = that.contactPhone;
            that.UserData.User.CUId = that.CUId;
            that.UserData.User.TaxID = that.taxID;
            that.UserData.User.UnitId = that.unitId;
            that.UserData.User.IsCooperationDataConsent = that.isCooperationDataConsent;
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("更新資訊成功"),
              showConfirmButton: false,
              timer: 3000,
              // didDestroy: () => {
              //   // 重整頁面
              //   location.reload();
              // },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
    logout: function (lang) {
      let that = this;
      let ek_login_token = Storage.get("ek_login_token");
      Storage.remove("ek_login_token");
      //location.reload();
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Logout",
        type: "post",
        data: {
          token: ek_login_token,
        },
        dataType: "json",
        error: function () {
          that.$router.push("/");
        },
        success: function () {
          // 轉到首頁
          that.$router.push("/");
        },
      });
    },
    applyClear: function () {
      let that = this;
      that
        .$swal({
          heightAuto: false,
          icon: "warning",
          title: "請注意!",
          html: that.$t(
            "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。"
          ),
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: that.$t("送出"),
          cancelButtonText: that.$t("取消"),
          input: "text",
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value != "DELETE") {
                resolve(that.$t("請輸入DELETE後再按下送出"));
              } else {
                resolve();
              }
            });
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/ApplyClear",
              type: "post",
              data: {
                token: Storage.get("ek_login_token"),
              },
              dataType: "json",
              error: function () { },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("帳號註銷成功"),
                    showConfirmButton: false,
                    timer: 3000,
                    allowOutsideClick: false,
                    didDestroy: () => {
                      Storage.remove("ek_login_token");
                      that.$router.push("/");
                    },
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          }
        });
    },
    validateEmail(email) {
      if (/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    hideInfo(str, s, e) {
      var length = str.length;
      if (length - (s + e) > 0) {
        var hide = "";
        hide = str.substr(0, s);
        for (var i = 0; i < length - (s + e); i++) {
          hide += "*";
        }
        hide += str.substr(length - e, e);
        return hide;
      }
      else {
        for (var i = 0; i < s + e; i++) {
          hide += "*";
        }
        return hide;
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#showPhone {
  position: absolute;
  top: 25%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}

#showEmail {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}

.cooperation-section {
  padding: 15px;
  background-color: #EEF7FF;
  border-radius: 10px;
}

.cooperation-section > .cooperation-consent-row,
.cooperation-section > .cooperation-field-row {
  width: 100%;
  margin: 0;
  float: none !important;
  overflow: hidden;
}

.cooperation-consent-row {
  cursor: pointer;
}

.cooperation-consent-row:focus {
  outline: 2px solid #173042;
  outline-offset: 3px;
}

.cooperation-consent-label {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin: 0 !important;
  float: none !important;
  cursor: pointer;
}

.cooperation-consent-label input {
  margin-top: 4px;
  margin-right: 8px;
  flex-shrink: 0;
  pointer-events: none;
}

.cooperation-field-row {
  padding-top: 15px;
}

.cooperation-field-row > div:first-child {
  float: left !important;
  margin-right: 10px;
}

.cooperation-field-row > div:last-child {
  float: right !important;
}

@media (max-width: 767px) {
  .cooperation-field-row > div:first-child,
  .cooperation-field-row > div:last-child {
    width: 100%;
    float: none !important;
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MemberInfo.vue